// extracted by mini-css-extract-plugin
export default {"root":"e-VHqz5u","sizeCompact":"m0-sMkFy","sizeMedium":"KGqX9wUx"};